let upsellSwiper = null;

function initupsellSlider() {
  // Destroy old instance if exists
  if (upsellSwiper && typeof upsellSwiper.destroy === 'function') {
    upsellSwiper.destroy(true, true);
    upsellSwiper = null;
  }

  const sliderEl = document.querySelector('.m-cart-upsell-slider');
  if (!sliderEl) return;

  // Create new slider
  upsellSwiper = new Swiper(sliderEl, {
    slidesPerView: 1.4,
    spaceBetween: 10,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      768: { slidesPerView: 1.4 },
      480: { slidesPerView: 1.4 }
    }
  });

  initUpsellAjax()  
}
function initUpsellAjax() {
  const upsellButtons = document.querySelectorAll('.m-cart-upsell-btn');
  upsellButtons.forEach(function(button) {
    const newButton = button.cloneNode(true);
    button.parentNode.replaceChild(newButton, button);
  });
  const freshButtons = document.querySelectorAll('.m-cart-upsell-btn');
  freshButtons.forEach(function(button) {
    button.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      if (button.disabled) return;
      const variantId = button.getAttribute('data-variant-id');
      const originalText = button.innerHTML;
      button.disabled = true;
      button.innerHTML = '<span>Adding...</span>';
      import('@theme/events').then(({ CartUpdateEvent }) => {
        const cartDrawer = document.querySelector('cart-drawer-component');
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(variantId), quantity: 1 }] })
        })
        .then(res => res.json())
        .then(() => fetch('/cart.js'))
        .then(res => res.json())
        .then(cart => {
          const event = new CartUpdateEvent(cart, 'manual-trigger', {
            itemCount: cart.item_count,
            source: 'cart-upsell',
            sections: {} 
          });
          document.dispatchEvent(event);
          if (cartDrawer?.hasAttribute('auto-open')) cartDrawer.open();
          button.innerHTML = '<span>Added!</span>';
          setTimeout(() => {
            button.disabled = false;
            button.innerHTML = originalText;
          }, 1500);
          if (typeof initupsellSlider === 'function') {
            setTimeout(() => {
              initupsellSlider();
            }, 1000);
          }
        })
        .catch(error => {
          console.error('Error adding to cart:', error);
          button.disabled = false;
          button.innerHTML = originalText;
          alert('Unable to add item to cart. Please try again.');
        });
      });
    });
  });
}
